import axios from 'axios';
import { store } from 'redux/store';
// import jwt_decode from 'jwt-decode';
import Urls from 'util/urls';
import string from 'util/string';
import {
  formatDate,
  showLoader,
  showToast,
  signOut,
  ServerErrorCode,
} from './utils';

/* eslint-disable */
Date.prototype.toJSON = function () {
  return formatDate(this, 'YYYY-MM-DDTHH:mm:ss.SSS');
};
/* eslint-enable */

export const RESPONSE_STATUS_CREATE = 'CREATE';
export const RESPONSE_STATUS_ERROR = 'ERROR';
// const RESPONSE_STATUS_EXCEPTION = 'EXCEPTION';

// instance
const instance = axios.create({ baseURL: Urls.baseUrl });
let currentRequestCount = 0;

const startRequest = (dontCountFlag) => {
  if (dontCountFlag) return;
  currentRequestCount++;
  showLoader();
};

const endRequest = (dontCountFlag) => {
  if (dontCountFlag) return;
  currentRequestCount--;
  if (currentRequestCount < 1) {
    currentRequestCount = 0;
    showLoader(false);
  }
};

export const sendPost = async (props) => {
  return await sendRequest({ ...props, method: 'POST' });
};

export const sendPut = async (props) => {
  return await sendRequest({ ...props, method: 'PUT' });
};

export const sendDelete = async (props) => {
  return await sendRequest({ ...props, method: 'DELETE' });
}
const sendRequest = async ({
  method = 'GET',
  body,
  url,
  headers,
  params,
  background = false,
  withToken = true,
  isRaw = false,
}) => {
  // decamelizeKeys
  // body = decamelizeKeys(body);
  // params = decamelizeKeys(params);

  let token;
  let requestHeader = { ...headers };
  const API_KEY = 'm_test_M2RmOWQ5NGEtNDMwYy00YmIyLWFiY2UtYTU5MzhmN2UxMTM2MDhhMjYyMDMtNjNjNi00NjdmLTg4YzktZGYzZjI4MjZkNDg1c18yNDAyMjcwNjIwMw';

  if (withToken) {
    // check user login
    let state = store.getState();
    if (!state?.user?.currentUser?.token) {
      // need login
      signOut();
      return Promise.reject();
    }
    // token = state.user.currentUser.token;
    token = API_KEY;
    requestHeader.Authorization = `Bearer ${token}`;
  }
  startRequest(background);
  let response;
  try {
    response = await instance({
      method: method.toLowerCase(),
      url,
      data: body,
      headers: requestHeader,
      params,
    });
    endRequest(background);

    if (isRaw) {
      return response.data;
    }
    let { status } = response.data;
    if (status === RESPONSE_STATUS_CREATE) {
      return response.data;
    } else if (status === RESPONSE_STATUS_ERROR) {
      let errorMessage = 'サーバーエラーです。';
      // if (errorCode < 601 + ServerErrorCode.length) {
      //   errorMessage = ServerErrorCode[ errorCode - 601 ];
      // }
      showToast(errorMessage);
      return Promise.reject(errorMessage);
    }

    // showToast(message || 'Unknown exception');
    showToast('不明な例外です。');
    // return Promise.reject(message || 'Unknown exception');
    return Promise.reject('不明な例外です。');
  } catch (ex) {
    endRequest(background);
    response = ex.response;
    let { status, message } = response?.data || {};
    if (
      withToken &&
      response?.status === 401 &&
      response?.data?.message === 'Unauthorized'
    ) {
      signOut();
      return Promise.reject(ex);
    }
    if (status === RESPONSE_STATUS_ERROR && !!message) {
      showToast(message);
    } else {
      showToast(message || 'Unknown exception');
    }

    return Promise.reject(ex);
  }
};

export default sendRequest;
